<app-top-bar title="PAYMENT.PAY_CARD" [customBack]="cancel"></app-top-bar>

<div class="content">
  <div [id]="flowContainerId" class="flow-container"></div>

  @if (loading) {
    <div class="loader-container">
      <mat-spinner class="loader"></mat-spinner>
      <p>{{ 'PAYMENT.PROGRESS' | translate }}</p>
    </div>
  }
</div>
